/**
 * EventEndDate
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import FormattedDate from '../FormattedDate';

// Selectors
import { makeSelectEventValue } from '../../services/events/selectors';

interface Props {
    endDate?: string;
    prefix?: string;
}

export class EventEndDate extends React.PureComponent<Props> {
    render() {
        const { endDate, prefix } = this.props;
        if (!endDate) return null;
        return (
            <React.Fragment>
                {prefix}
                <FormattedDate value={endDate} format="MMM D" />
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    endDate: makeSelectEventValue('endDate')
});

export default connect(mapStateToProps)(EventEndDate);
